export default __webpack_public_path__ + "static/media/auditorium_image@3x.8e37ecf2.jpg";